import gql from 'graphql-tag';


export const UPDATE = gql(`
mutation($data: ModeloMenuDirectiveInputType!){
    menuDirectiveMutation{
        updateMenuDirective(data:$data)
    }
}
`);

export const ADD = gql(`
mutation($data: ModeloMenuDirectiveInputType!){
    menuDirectiveMutation{
        addMenuDirective(data:$data)
    }
}
`);

export const GRANTACCESS = gql(`
mutation($objectId: Int!, $objectGroup: ObjectGroupInputType!, $objectType: String!, $applicationId: Int!, $applicationVersion: Int!){
    objectGroupMutation{
        grantAccessToObjectGroup(objectId:$objectId, objectGroup:$objectGroup, objectType:$objectType, applicationId:$applicationId, applicationVersion:$applicationVersion)
    }
}
`);





